<template>
  <div>
    <c-logo />
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="thanks_text"
      v-html="thanks_text"
    />
    <!--eslint-enable-->
    <div v-else>
      <c-title>Vielen Dank!</c-title>

      <p class="mt-5">
        Ihr Antrag ist bei uns eingegangen. Sie erhalten in Kürze eine Bestätigung inklusive einer Kopie des Antrags per E-Mail. Wenn Sie diese nicht innerhalb weniger Minuten erhalten, überprüfen Sie bitte Ihren Spam-Ordner und wenden sich ggf. an die Hamburgische Kulturstiftung per
        <a
          href="mailto:assistenz@kulturstiftung-hh.de"
          target="_blank"
        > E-Mail </a>
        oder telefonisch unter 040 339099.
      </p>
    </div>
  </div>
</template>

<script>
import CTitle from '../components/CTitle.vue'
import CLogo from '../components/CLogo.vue'

export default {
  name: 'VThankYou',

  components: {
    CTitle,
    CLogo
  },

  computed: {
    thanks_text () {
      return this.$store.state.textsInfo.thanks_text
    }
  }
}
</script>
